import { localStorageNames } from '@src/shared/constants/local-storage-names';

/**
 * Visible Tia dialog (white card) floor. The aside also has `p-4` gutters
 * (16px each side), so the outer panel min/default adds those in.
 */
export const ASSISTANT_DIALOG_MIN_WIDTH = 435;
export const ASSISTANT_PANEL_GUTTER = 32; // p-4 × 2
export const ASSISTANT_PANEL_MIN_WIDTH =
  ASSISTANT_DIALOG_MIN_WIDTH + ASSISTANT_PANEL_GUTTER; // 467
export const ASSISTANT_PANEL_DEFAULT_WIDTH = ASSISTANT_PANEL_MIN_WIDTH;
export const ASSISTANT_PANEL_MAX_WIDTH = 720;

export function clampAssistantPanelWidth(width: number): number {
  return Math.min(
    ASSISTANT_PANEL_MAX_WIDTH,
    Math.max(ASSISTANT_PANEL_MIN_WIDTH, width)
  );
}

export function readStoredAssistantPanelWidth(): number {
  try {
    const raw = localStorage.getItem(localStorageNames.assistantPanelWidth);
    if (!raw) return ASSISTANT_PANEL_DEFAULT_WIDTH;
    const parsed = Number(raw);
    if (!Number.isFinite(parsed)) return ASSISTANT_PANEL_DEFAULT_WIDTH;
    const clamped = clampAssistantPanelWidth(parsed);
    // Persist when an older, too-narrow value is lifted to the new floor.
    if (clamped !== parsed) persistAssistantPanelWidth(clamped);
    return clamped;
  } catch {
    return ASSISTANT_PANEL_DEFAULT_WIDTH;
  }
}

export function persistAssistantPanelWidth(width: number): void {
  try {
    localStorage.setItem(
      localStorageNames.assistantPanelWidth,
      String(clampAssistantPanelWidth(width))
    );
  } catch {
    // Storage can be full or blocked; width still lives in memory.
  }
}
